import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, DropdownList, Icons } from '@/js/libs/ui/src/V2';

import { useThemeController } from 'src/theme/ThemeController.tsx';

export const ThemeButton = memo(function ThemeButton() {
  const [t] = useTranslation(['common']);
  const { isSwitching, setTheme, themeId, isSystem } = useThemeController();

  const handleSetPrimary = useCallbackRef(() => setTheme('primary'));
  const handleSetPrimaryDark = useCallbackRef(() => setTheme('primaryDark'));
  const handleSetSystem = useCallbackRef(() => setTheme('system'));

  return (
    <DropdownList
      minWidth={false}
      dataTestId='ui-mode-select'
      renderButton={() => (
        <Button iconOnly ghost isLoading={isSwitching} title={t('common:THEME')}>
          <Icons.DayNight size={20} />
        </Button>
      )}>
      <DropdownList.DropdownItem onClick={handleSetPrimary} dataTestId='primary-mode' isSelected={!isSystem && themeId === 'primary'}>
        {t('common:THEME_PRIMARY')}
      </DropdownList.DropdownItem>

      <DropdownList.DropdownItem
        onClick={handleSetPrimaryDark}
        dataTestId='primary-dark-mode'
        isSelected={!isSystem && themeId === 'primaryDark'}>
        {t('common:THEME_PRIMARY_DARK')}
      </DropdownList.DropdownItem>

      <DropdownList.DropdownItem onClick={handleSetSystem} isSelected={isSystem}>
        {t('common:THEME_SYSTEM')}
      </DropdownList.DropdownItem>
    </DropdownList>
  );
});
